import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../LibrariesImport";

export default class Typewriter {
    constructor() {
        this.bannerSearch = document.querySelectorAll(".banner-search");

        if (this.bannerSearch.length === 0) {
            return;
        }

        this.bannerSearch.forEach((bannerSearch) => {
            this.initTypewriter(bannerSearch);
        });

        GlobalVariables.resizeCallbacks.push(this);
    }

    calculateMinWidth(typedPart, textArray) {
        const longestText = textArray.reduce((a, b) => a.length > b.length ? a : b, "");
        const tempDiv = document.createElement("div");
        const computedStyles = window.getComputedStyle(typedPart);

        // Apply the same styles to tempDiv
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.style.whiteSpace = "nowrap";
        tempDiv.style.font = computedStyles.font;
        tempDiv.style.fontSize = computedStyles.fontSize;
        tempDiv.style.fontWeight = computedStyles.fontWeight;
        tempDiv.style.letterSpacing = computedStyles.letterSpacing;
        tempDiv.style.lineHeight = computedStyles.lineHeight;
        tempDiv.innerHTML = longestText;
        document.body.appendChild(tempDiv);
        const minWidth = tempDiv.offsetWidth + 10;
        document.body.removeChild(tempDiv);

        // Set the minimum width of the typed-part
        typedPart.style.minWidth = `${minWidth}px`;
    }

    initTypewriter(bannerSearch) {
        const typewriter = bannerSearch.querySelector(".typewriter");
        const typedPart = typewriter.querySelector(".typed-part");
        const submit = bannerSearch.querySelector(".btn-search");
        const textData = typedPart.getAttribute("data-text");
        const textArray = textData.split(";");

        let cursor = document.createElement("span");
        cursor.className = "cursor";
        cursor.innerHTML = "|";
        typedPart.appendChild(cursor);

        // Calculate the initial minimum width
        this.calculateMinWidth(typedPart, textArray);

        let currentIndex = 0;

        function typeText() {
            let text = textArray[currentIndex];
            typedPart.innerHTML = "";
            typedPart.appendChild(cursor);
            let charIndex = 0;

            function typeChar() {
                if (charIndex < text.length) {
                    typedPart.innerHTML = text.substring(0, charIndex + 1);
                    typedPart.appendChild(cursor);
                    charIndex++;
                    setTimeout(typeChar, Math.floor(Math.random() * (200 - 40 + 1)) + 40); // Random typing speed between 40 and 200 ms
                } else {
                    setTimeout(() => {
                        currentIndex = (currentIndex + 1) % textArray.length;
                        typeText();
                    }, 2000); // Pause duration between phrases
                }
            }

            typeChar();
        }

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            bannerSearch.classList.add('is-focused');
        } else {
            typeText();

            // Blinking cursor effect
            gsap.to(cursor, {
                opacity: 0,
                repeat: -1,
                yoyo: true,
                ease: "power2.inOut",
                duration: 0.5
            });
        }

        bannerSearch.addEventListener("click", () => {
            bannerSearch.classList.add("is-focused");
            bannerSearch.querySelector("input").focus();
        });

        bannerSearch.addEventListener("focusin", () => {
            bannerSearch.classList.add("is-focused");
        });

        bannerSearch.addEventListener("focusout", (e) => {
            if (!bannerSearch.contains(e.relatedTarget)) {
                bannerSearch.classList.remove("is-focused");
            }
        });

        bannerSearch.addEventListener("mouseenter", () => {
            if (!bannerSearch.classList.contains("is-focused")) {
                submit.classList.add("is-hover");
            }
        });

        bannerSearch.addEventListener("mouseleave", () => {
            submit.classList.remove("is-hover");
        });
    }

}